<template>
  <div class="scl-ad">
    <PreLoader v-if="isLoading"/>
    <div class="head-block">
      <v-btn color="primary" @click="$router.go(-1)" v-text="$t('back')"/>
      <div style="font-size: 18px; font-weight: bold" v-html="$t('allShift')"/>
      <v-btn color="primary" @click="openModal('addShift', {})" v-text="$t('addShift')"/>
    </div>
    <v-simple-table class="dash-tab">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-table" v-html="$t('shiftName')"/>
            <th/>
            <th/>
          </tr>
        </thead>
        <tbody>
          <tr v-for="shift in allSchoolShifts" :key="shift.id">
            <td class="shift-name" v-html="shift.name"/>
            <td style="width: 50px">
              <v-btn icon color="primary" @click="openModal('editAll', shift)">
                <v-icon color="primary">mdi-pencil-outline</v-icon>
              </v-btn>
            </td>
            <td style="width: 50px">
              <v-btn icon color="red" @click="deleteShift(shift.id, false)">
                <v-icon color="red">mdi-trash-can-outline</v-icon>
              </v-btn>
                    </td>
                </tr>
        </tbody>
      </template>
    </v-simple-table>
        <!--MODAL FOR SHIFT AND SHIFT-TIME-->
    <v-dialog v-model="shiftDialog">
      <div class="modal-container" style="height: max-content;">
        <template v-if="mode === 'addShift'">
          <ShiftCreateEdit :shiftObj="shiftObj" :mode="mode" @createShift="submitCreateShift" @closeModal="closeModal"/>
        </template>
<!--        <template v-if="mode === 'addShiftTime'">1-->
<!--          <ShiftTimeCreateEdit v-if="mode === 'addShiftTime'" :mode="mode" :shiftTimeList="shiftTimeList"-->
<!--                               @addShiftTimeArray="prepareShiftTime" @saveShiftTimes="submitShiftTimes"-->
<!--                               @removeShiftTime="deleteShiftTime" @closeModal="closeModal"/>-->
<!--        </template>-->
        <template v-if="mode === 'editAll'">
          <ShiftCreateEdit :shiftObj="shiftObj" :mode="mode" @createShift="submitCreateShift" @closeModal="closeModal"/>
            <v-divider style="padding-bottom: 16px"/>
          <ShiftTimeCreateEdit :mode="mode" :shiftTimeList="shiftTimeList"
                               @addShiftTimeArray="prepareShiftTime" @saveShiftTimes="submitShiftTimes"
                               @removeShiftTime="deleteShiftTime" @closeModal="closeModal"/>
          <div class="btn-actions">
            <v-btn color="primary" @click="closeModal">{{ $t('cancel') }}</v-btn>
            <v-btn color="green" @click="submitUpdateAllShiftAndTimes">{{ $t('save') }}</v-btn>
          </div>
        </template>
      </div>
    </v-dialog>
    <!--MODAL FOR DELETE SHIFT-->
    <v-dialog v-model="deleteDialog">
      <div class="modal-container">
        <h2 v-html="$t('areYouSureToDeleteThisShift')"/>
          <div class="btn-actions">
            <v-btn color="primary" @click="deleteDialog = false" v-html="$t('cancel')"/>
            <v-btn color="red" @click="deleteShift('', true)" v-html="$t('remove')"/>
          </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import ShiftService from '@/_services/shift.service'
import ShiftTimeService from '@/_services/shift-time.service'
import ShiftCreateEdit from '@/components/shift/ShiftCreateEdit'
import ShiftTimeCreateEdit from '@/components/shift/ShiftTimeCreateEdit'
import moment from 'moment'
import PreLoader from '@/components/preloader/PreLoader'

export default {
  components: {
    ShiftCreateEdit,
    ShiftTimeCreateEdit,
    PreLoader
  },
  data () {
    return {
      isLoading: false,
      shiftDialog: false,
      deleteDialog: false,
      shiftObj: {
        name: '',
        schoolId: '',
        startTime: '',
        endTime: '',
      },
      allSchoolShifts: [],
      shiftTimeList: [],
      mode: ''
    }
  },

  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    }
  },

  created () {
    this.fetchSchoolShifts()
  },

  methods: {
    fetchSchoolShifts () {
      this.isLoading = true
      ShiftService.getAllBySchool(this.school.id).then((res) => {
        this.allSchoolShifts = res
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

     openModal (mode, shift) {
      this.mode = mode
      this.shiftObj.schoolId = this.school.id
      if (mode === 'addShift') {
        this.shiftObj.name = ''
        this.shiftTimeList = []
      } else {
        this.shiftObj.name = shift.name
        this.shiftObj.id = shift.id
        this.shiftObj.endTime = shift.endTime
        this.shiftObj.startTime = shift.startTime
        this.getShiftTimesByShift(shift.id)
      }
      this.shiftDialog = true
    },

    closeModal () {
      this.shiftDialog = false
    },

    submitCreateShift () {
      ShiftService.create(this.shiftObj).then((res) => {
        this.mode = 'editAll'
        this.shiftObj.id = parseInt(res.message)
        this.fetchSchoolShifts()
      }).catch(err => this.$toast.error(err))
    },

    prepareShiftTime () {
      const shiftTimeObj = {
        name: this.shiftTimeList.length + 1,
        startTime: '08:00',
        endTime: '09:00',
        timeStart: new Date(),
        timeEnd: new Date(),
        shiftId: this.shiftObj.id,
        schoolId: this.school.id
      }
      ShiftTimeService.create(shiftTimeObj).then((res) => {
        shiftTimeObj.id = parseInt(res.message)
        this.shiftTimeList.push(shiftTimeObj)
      })
    },

    async submitShiftTimes () {
      let requests
      this.shiftTimeList = this.shiftTimeList.map((shiftTime) => {
        shiftTime.startTime = shiftTime.timeStart // moment(shiftTime.timeStart).format('HH:mm')
        shiftTime.endTime = shiftTime.timeEnd // moment(shiftTime.timeEnd).format('HH:mm')
        shiftTime.schoolId = this.school.id
        return shiftTime
      })
      if (this.mode === 'addShiftTime') {
        requests = this.shiftTimeList.map((shiftTime) => {
          return new Promise((resolve, reject) => {
            ShiftTimeService.create(shiftTime).then((res) => {
              resolve(res)
            }).catch((err) => {
              reject(err)
              this.$toast.error(err)
            })
          })
        })
      } else {
        requests = this.shiftTimeList.map((shiftTime) => {
          return new Promise((resolve, reject) => {
            ShiftTimeService.update(shiftTime).then((res) => {
              resolve(res)
            }).catch((err) => {
              reject(err)
              this.$toast.error(err)
            })
          })
        })
      }
      if (requests.length) {
        const results = await Promise.all(requests)
        this.fetchSchoolShifts()
        this.$toast.success(this.$t('success'))
        this.closeModal()
      } else {
        this.$toast.info(this.$t('addLessonTime'))
      }
    },

    getShiftTimesByShift (shiftId) {
      this.shiftTimeList = []
      ShiftTimeService.getAllByShiftId(shiftId).then((res) => {
        this.shiftTimeList = res.map((item) => {
          item.timeStart = /* new Date(moment(`1970-01-01 ${ */ item.startTime // }`))
          item.timeEnd = /* new Date(moment(`1970-01-01 ${ */ item.endTime // }`))
          return item
        }).sort((a, b) => a.name - b.name)
      }).catch(err => this.$toast.error(err))
    },

    submitUpdateAllShiftAndTimes () {
      ShiftService.update(this.shiftObj)
          .then(() => this.submitShiftTimes())
          .catch(err => this.$toast.error(err))
    },

    deleteShift (shiftId, bool) {
      if (bool) {
        ShiftService.removeShift(this.shiftObj.id).then(() => {
          this.fetchSchoolShifts()
          this.$toast.success(this.$t('successDeleted'))
          this.deleteDialog = false
        }).catch(err => this.$toast.error(err))
      } else {
        this.shiftObj.id = shiftId
        this.deleteDialog = true
      }
    },

    deleteShiftTime (shiftTimeObj) {
      const index = this.shiftTimeList.indexOf(shiftTimeObj)
      if (this.mode === 'addShiftTime') {
        this.shiftTimeList.splice(index, 1)
      } else if (this.mode === 'editAll') {
        ShiftTimeService.remove(shiftTimeObj.id).then(() => {
          this.shiftTimeList.splice(index, 1)
          this.$toast.success(this.$t('successDeleted'))
        }).catch(err => this.$toast.error(err))
      }
    }
  }
}
</script>

<style scoped lang="scss">
@media (max-width: 768px) {
}
.head-block{
    display: flex;
    flex-direction: row;
    gap: 8px;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}
th, td, tr{
    vertical-align: middle;
    text-align: center!important;
    border: rgba(198, 203, 212, 0.58) solid 1px;
}
td{
    padding: 10px 16px !important;
}
    .shift-container {
        .go-back {
            font-size: 16px;
            height: 30px;
            line-height: 0;
            padding: 0 5px;
            border-radius: 5px;
            cursor: pointer;
        }
        .shift-table {
            max-width: 1024px;
            margin: 0 auto;
            .shift-name {
                font-weight: bold;
            }
        }
    }
</style>
